import type {
  CatalogMetric,
  GetDataModelCatalogResponse,
} from "./dataModelCatalog.types";
import type {
  CatalogMetricApi,
  GetDataModelCatalogApiResponse,
} from "./dataModelCatalogApi.types";

export const mapLiveCatalogMetric = (
  metric: CatalogMetricApi,
): CatalogMetric => ({
  id: metric.id,
  name: metric.name,
  isAutoGenerated: metric.isAutoGenerated,
  sourceTableIds: metric.sourceTableId ? [metric.sourceTableId] : [],
});

export const mapLiveCatalogResponse = (
  response: GetDataModelCatalogApiResponse,
): GetDataModelCatalogResponse => ({
  data: {
    tables: response.data.tables,
    metrics: response.data.metrics.map(mapLiveCatalogMetric),
  },
  meta: response.meta,
});
